/**
 * Radii — extracted from Figma landing frame 58:39161.
 *
 *   4   → checkbox
 *   6   → select menu item
 *   8   → search card / menus
 *   12  → content-card corners (top or bottom half)
 *   20  → hero mask
 *   24  → open dropdown panel
 *   54  → carousel arrow button
 *   100 → pills (CTAs, madlib chips)
 *
 * IMPORTANT: MUI's `sx` prop treats a *number* for borderRadius as a
 * multiplier of `theme.shape.borderRadius`. Always use `radius('md')`
 * (pixel string) in `sx` / `*.styles.ts` — never a bare number.
 */
export const radii = {
  none: 0,
  xs: 4,
  sm: 6,
  md: 8,
  card: 12,
  lg: 20,
  xl: 24,
  arrow: 54,
  pill: 100,
} as const;

export type RadiusToken = keyof typeof radii;

/** Pixel string for safe use inside MUI `sx` props. */
export function radius(token: RadiusToken): string {
  return `${radii[token]}px`;
}

declare module '@mui/material/styles' {
  interface Theme {
    radii: typeof radii;
    radius: typeof radius;
  }
  interface ThemeOptions {
    radii?: typeof radii;
    radius?: typeof radius;
  }
}

export const shapeOptions = {
  // Base unit for MUI's sx multiplier (`borderRadius: 1` → 8px).
  borderRadius: radii.md,
} as const;
